import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

document.querySelectorAll('.slider--slider').forEach((el) => {
  const swiper = new Swiper(el, {
    modules: [Autoplay],
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    spaceBetween: 20,
    draggable: true,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3.5,
      },
    },
  });

  const parent = el.parentElement;
  if (!parent) return;

  parent.querySelector('.slider--arrow.next')?.addEventListener('click', () => swiper.slideNext());
  parent.querySelector('.slider--arrow.prev')?.addEventListener('click', () => swiper.slidePrev());
});
